import React from 'react';
import moment from 'moment';

import './index.scss';

const getAvailability = (membership) => {
  return `${membership.available} of ${membership.count}`;
};
const MemberShip = ({ details, selectedConversation }) => {
  return (
    <div className="client-profile__card">
      <h1 className="client-profile__card__heading">Membership info</h1>
      <div className="client-profile__card__content">
        {details &&
          details.pricing &&
          details.pricing.map((membership) => {
            return (
              <ul className="memebership-card">
                <li>
                  <span className="client-profile__card__content__list-head">
                    Type:
                  </span>
                  <span className="client-profile__card__content__list-text">
                    {membership.name}
                  </span>
                </li>
                <li>
                  <span className="client-profile__card__content__list-head">
                    Available:
                  </span>
                  <span className="client-profile__card__content__list-text">
                    {getAvailability(membership)}
                  </span>
                </li>
                {membership && membership.span && (
                  <li>
                    <span className="client-profile__card__content__list-head">
                      Expiry:
                    </span>
                    <span className="client-profile__card__content__list-text">
                      {moment(membership.span.end_date).format('LL')}
                    </span>
                  </li>
                )}
              </ul>
            );
          })}
      </div>
    </div>
  );
};

export default MemberShip;
